export const Posts = {
    "vzdelavacie-aktivity" : [
        {
            id: "visual_art_lab",
            banner: "/assets/visual_art_lab_cover.jpg",
            heading: "Visual Art Lab",
            date: "jún a september 2025",
            coverPost : true,
            content: <p>
                Projekt <i>Visual Art Lab</i> prináša do mesta Humenné inovatívny vzdelávací a umelecký projekt, ktorý
                spája vizuálne umenie, technológie a verejný priestor. V rámci programu vznikne séria workshopov,
                prednášok, seminárov a umeleckých prezentácií, vyvrcholená experimentálnym audiovizuálnym koncertom.
                Cieľom je podporiť tvorivosť, vzdelávanie a medziodborovú spoluprácu v oblasti súčasného umenia....
            </p>,
            link: "/post/visual_art_lab"
        },
        {
            id: "open_photo_space_2024",
            banner: "/assets/open_photo.jpg",
            heading: "OPEN FOTO SPACE II.",
            date: "03. jún - 09. jún 2024",
            coverPost : true,
            content: <p>
                <i>OPEN FOTO SPACE II.</i> je druhý ročník fotografických vzdelávacích aktivít,
                organizovaný pointA o.z. v spolupráci so Strednou odbornou školou polytechnickou
                v Humennom a fotoklubom Reflex. Projekt pozostáva zo série workshopov, prednášok,
                seminárov a konzultácií /FOTOteoretikom pre študentov, odbornú verejnosť ako aj
                nadšencov fotografie...
            </p>,
            link: "/post/open_photo"
        },
        {
            id: "open_photo_space_2023",
            banner: "/assets/open_photo_2023.jpg",
            heading: "OPEN FOTO SPACE I.",
            date: "11. august - 13. august 2023",
            content: <p>
                <i>OPEN FOTO SPACE 2023</i> je cyklus fotografických workshopov Genius loci, organizovaný pointA
                o.z. v
                spolupráci s Vihorlatským múzeom v Humennom.
            </p>,
            link: "/post/open_photo_2023"
        }
    ],
    "foto-potulky": [
        {
            id: "foto_potulky_2024",
            banner: "/assets/fotopotulky_cover_2024.jpg",
            heading: "FOTOpotulky 2024",
            date: "01. august - 31. október 2024",
            content: <p>
                <i>FOTOpotulky</i> je 4.ročník mikroFESTIVALU súčasnej slovenskej fotografie. Dvojica výstav „DOTYKY S ČASOM“ a „TRADÍCIE A FOTOGRAFIA“ vo Vihorlatskom múzeu spolu s autorskou výstavou Ľudovíta Hrušku RÁZCESTIE v MsKS a výstavou z tvorby mladých „Z UHLA DETAILU“ vo Vihorlatskej knižnici tvoria prázdninový program festivalu FOTOpotulky, ktorý spája minulosť a prítomnosť slovenskej fotografie, prezentujúc diela priekopníkov aj súčasných umelcov....
            </p>,
            link: "/post/foto_potulky_2024"
        },
        {
            id: "foto_potulky_2023",
            banner: "/assets/fotopotulky_cover.jpg",
            heading: "FOTOpotulky 2023",
            date: "11. august - 31. október 2023",
            content: <p>
                <i>FOTOpotulky</i> je mikrofestival súčasnej slovenskej fotografie, organizovaný občianskym združením pointA.
                Cieľom podujatia je širšej verejnosti predstaviť aktuálne dianie vo “svete” slovenskej fotografie, ale i tvorbu humenčanov.
                Sériu fotografických výstav a fotografických intervencií vo verejnom priestore a inštitúciách mesta bude možné vzhliadnuť počas mesiacov september a október 2023...
            </p>,
            link: "/post/foto_potulky_2023"
        }
    ],
    "slovak-art-ways": [
        {
            id: "slovak_art_ways_2025",
            banner: "/assets/slovak_art_ways_2025_cover.jpg",
            heading: "Slovak Art Ways 2025",
            date: "17th July - 26th July 2025",
            content: <p>
                The project culminates in a group exhibition of contemporary visual art. It explores the concept of borders—both physical and metaphorical—through the lens of lines as a visual and thematic element. The black line serves as a powerful symbol, representing connection as well as the complexity of human experience...
            </p>,
            link: "/post/slovak_art_ways_2025",
            secondLink : {
                link : "/post/slovak_art_ways_2025_en_curators_text",
                label : "Kurátorský text"
            }
        },
        {
            id: "slovak_art_ways_2024",
            banner: "/assets/slovak_art_ways_cover.jpg",
            heading: "Slovak Art Ways",
            date: "15th August - 30th September 2024",
            content: <p>
                <i>The Slovak Art Ways</i>  project aims to present Slovak art abroad and to involve Slovak artists in international networks.
                The project is a continuation of a series of international presentations and exhibitions of contemporary visual art organised
                in cooperation with KONIAREŇ Gallery - Space for Contemporary Art since 2014.
                This year’s volume is held in the Gallery of the Faculty of Arts of Ss. Cyril and Methodius University in Skopje, North Macedonia...
            </p>,
            link: "/post/slovak_art_ways",
            secondLink : {
                link : "/post/slovak_art_ways_en_curators_text",
                label : "Kurátorský text"
            }
        }
    ],
    "clanky" : [
        {
            id: "visual_art_lab_clanok",
            banner: "/assets/visual_art_lab_cover.jpg",
            heading: "Visual Art Lab (Článok)",
            date: "jún a september 2025",
            coverPost : true,
            content: <p>
                Projekt <i>Visual Art Lab</i> prináša do mesta Humenné inovatívny vzdelávací a umelecký projekt, ktorý
                spája vizuálne umenie, technológie a verejný priestor. V rámci programu vznikne séria workshopov,
                prednášok, seminárov a umeleckých prezentácií, vyvrcholená experimentálnym audiovizuálnym koncertom.
                Cieľom je podporiť tvorivosť, vzdelávanie a medziodborovú spoluprácu v oblasti súčasného umenia....
            </p>,
            link: "/post/visual_art_lab_clanok",
            slideshows : [
                [
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_01.jpg" },
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_02.jpg" },
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_03.jpg" },
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_04.jpg" },
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_05.jpg" },
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_06.jpg" },
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_07.jpg" },
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_08.jpg" },
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_09.jpg" },
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_10.jpg" },
                    {url : "/assets/visual_art_lab_clanok/6/visual_art_lab_11.jpg" },
                ],
                [
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_01.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_02.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_03.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_04.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_05.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_06.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_07.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_08.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_09.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_10.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_11.jpg" },
                    {url : "/assets/visual_art_lab_clanok/12/visual_art_lab_12.jpg" },
                ]
            ]
        },
        {
            id: "cesta_k_portretu",
            banner: "/assets/cesta_k_portretu/cesta_k_portretu_title.jpg",
            heading: "Cesta k portrétu: Výstava, ktorá osvetľuje klasickú fotografickú tému",
            date: null,
            content: <p>
                Humenčania majú možnosť vidieť výstavu plnú kreatívnych prístupov k tematike portrétu, ktorá vznikla z dielne účastníkov júnových workshopov OPEN FOTO SPACE 2024.
                Študenti sa počas týchto workshopov zhodli, že sa im otvorilo kreatívne okno s nekonečnými možnosťami v komponovaní portrétu.
                Mladí účastníci sérií vzdelávacích aktivít OPEN FOTO SPACE 2024...
            </p>,
            link: "/post/cesta_k_portretu",
            slideshow : [
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_03.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_02.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_01.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_04.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_05.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_06.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_07.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_09.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_08.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_10.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_11.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_12.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_13.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_14.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_15.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_16.jpg" },
                {url : "/assets/cesta_k_portretu/cesta_k_portretu_17.jpg" },
            ]
        },
        {
            id: "fotopotulky_humenne",
            banner: "/assets/fotopotulky_humenne/fotopotulky_humenne_09.jpg",
            heading: "Humenné má svoj fotografický festival: FOTOpotulky 2024 -  vrstvy času a pamäte",
            date: null,
            content: <p>
                Mesto Humenné sa zaradilo medzi mestá na Slovensku, ktoré majú vlastný fotografický festival, ako napríklad Bratislava, Piešťany, Banská Štiavnica či Zvolen.
                FOTOpotulky, ktoré prebiehajú už štvrtý rok, prinášajú súčasnú slovenskú fotografiu priamo do verejných priestorov a kultúrnych inštitúcií v Humennom...
            </p>,
            link: "/post/fotopotulky_humenne",
            slideshow : [
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_03.jpg", label : "FOTOreport z komentovaných prehliadok a prednášky 2. 10. 2024 SOŠ polytechnická Humenné" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_02.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_01.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_04.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_05.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_06.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_07.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_09.jpg", label : "FOTOreport z komentovaných prehliadok 6. 9. 2024 so SOŠ pedagogickou EBG" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_08.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_10.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_11.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_12.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_13.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_14.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_15.jpg" },
                {url : "/assets/fotopotulky_humenne/fotopotulky_humenne_16.jpg" },
            ]
        },
        {
            id: "slovak_art_ways_photo_article",
            banner: "/assets/slovak_art_ways_cover.jpg",
            heading: "Slovenskí umelci v Skopje: Slovak Art Ways 2024",
            date: null,
            content: <p>
                Do Galérie Fakulty umenia Univerzity Sv. Cyrila a Metoda v Skopje zavítal projekt <i>Slovak Art Ways 2024</i>,
                ktorý prináša aktuálne trendy slovenského vizuálneho umenia do medzinárodného kontextu.
                Výstava s názvom <i>TRAILS OF TWO WORLDS</i> bola slávnostne otvorená 15. augusta 2024 a potrvá až do 30. septembra...
            </p>,
            link: "/post/slovak_art_ways_photo_article",
            slideshow : [
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_01.jpg", label : "Matrica ako ring" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_02.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_03.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_04.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_05.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_06.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_07.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_09.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_08.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_10.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_11.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_12.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_13.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_14.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_15.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_16.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_17.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_18.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_19.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_20.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_21.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_22.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_23.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_24.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_25.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_26.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_27.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_28.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_29.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_30.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_31.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_32.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_33.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_34.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_35.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_36.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_37.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_38.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_39.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_40.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_41.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_saw_42.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_01.jpg", label : "Trails of two worlds" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_02.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_03.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_04.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_05.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_06.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_07.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_09.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_08.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_10.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_11.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_12.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_13.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_14.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_15.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_16.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_17.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_18.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_19.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_20.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_21.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_22.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_23.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_24.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_25.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_26.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_27.jpg" },
                {url : "/assets/slovak_art_ways_photos/slovak_art_ways_trails_28.jpg" },
            ]
        }
    ],
    "aktualne-akcie": [
        {
            id: "beseda_simkulic",
            banner: "/assets/vystavy/beseda_simkulic_cover.jpg",
            heading: "Beseda s autorom Mariánom Šimkuličom",
            date: "5. jún 2025 o 16:00",
            content: <p>
                Vihorlatská knižnica v Humennom a pointA o.z. vás pozývajú na verejnú prezentáciu najnovšej knihy spisovateľa, novinára a autora rozhlasových fíčrov, Mariána Šimkuliča....
            </p>,
            link: "/post/beseda_simkulic"
        },
        {
            id: "genearcheohistoriografia",
            banner: "/assets/vystavy/genearcheohistoriografia_cover.jpg",
            heading: "Genearcheohistoriografia",
            date: "29. apríl – 30. jún 2025",
            content: <p>
                Výstava Genearcheohistoriografia prináša pohľad na prostredie Jáchymovských uránových baní. Spája dokumentárnu a konceptuálnu fotografiu Leny Jakubčákovej a Márie Piatrikovej, ktoré na miestach miznúcich pracovných táborov zaznamenávajú vzťah medzi minulosťou a prítomnosťou...
            </p>,
            link: "/post/genearcheohistoriografia"
        },
        {
            id: "veronika_a_jej_priatelia",
            banner: "/assets/vystavy/veronika_cover.jpg",
            heading: "Veronika a jej priatelia",
            date: "03. marec - 23. marec 2025",
            content: <p>
                Multižánrová kolektívna výstava <i>„Veronika a jej priatelia“</i>, ktorá sa koná v priestoroch Jazdiarne v múzeu je venovaná spomienke na vizuálnu umelkyňu a dokumentaristku Veroniku Bažalikovú (1978–2023) a prostredníctvom diel vystavujúcich autorov reflektuje jej život, tvorbu a odkaz...
            </p>,
            link: "/post/veronika_a_jej_priatelia",
            secondLink : {
                link : "/post/veronika_a_jej_priatelia_curators_text",
                label : "Kurátorský text"
            }
        },
        {
            id: "ritualy_doby",
            banner: "/assets/vystavy/ritualy_doby_cover.jpg",
            heading: "Rituály doby",
            date: "21. január 2025 – 21. marec 2025",
            content: <p>
                Projekt <i>„Rituály doby: Digitálne stopy a štruktúry ohňa“</i> spája dvoch tvorcov Vladimíra Vajsa a Mariána Kusika. Obaja sa vo svojej tvorbe venujú  témam súčasného sveta, pričom každý sa ich zmocňuje formou privátneho rituálu za pomoci štruktúr a vrstvenia materiálov...
            </p>,
            link: "/post/ritualy_doby"
        }
    ]
}

export const PublicationsList = [
    {
        id : "necakana_navsteva",
        banner : "assets/publikacie/necakana_navsteva_titulka.jpg",
        heading : <p>Nečakaná návšteva - Marián Šimkulič<br/><i>ISBN 978-80-973102-9-5</i></p>,
        link : "/post/necakana_navsteva"
    },
    {
        id : "slovak_art_ways_catalog_sk",
        banner : "assets/SKOPJE_2024_SK_titulka.jpg",
        heading : <p>Slovak Art Ways / TRAILS OF TWO WORLDS / Skopje 2024<br/>slovensko - anglická verzia<br/><i>ISBN 978-80-973102-6-4</i></p>,
        link : "/post/slovak_art_ways_sk_catalog",
        secondLink : {
            link : "/post/slovak_art_ways",
            label : "Viac o projekte"
        }
    },
    {
        id : "slovak_art_ways_catalog_mkd",
        banner : "assets/SKOPJE_2024_MK_titulka.jpg",
        heading : <p>Slovak Art Ways / TRAILS OF TWO WORLDS / Skopje 2024<br/>macedónsko - anglická verzia<br/><i>ISBN 978-80-973102-8-8</i></p>,
        link : "/post/slovak_art_ways_mkd_catalog",
        secondLink : {
            link : "/post/slovak_art_ways_mkd",
            label : "Viac o projekte"
        }
    }
]